export const OverlayOptions = {
    AEOVERLAY: 'ae-overlay',
    HMEOVERLAY: 'hme-overlay',
    OMEOVERLAY: 'ome-overlay',
    DEFAULT: 'default'
};
